import React from "react";
import { useRouter } from "next/router";
import { useClerk } from "@clerk/nextjs";
import { Button } from "design_system";
import { AuthWrapper } from "./AuthWrapper";
import path from "constants/path";
import useLabels from "hooks/useLabels";

interface AlreadySignedInProps {
  includeAuthWrapper?: boolean;
}

/**
 * Component to display when a user is already signed in allowing them to sign out or return home.
 *
 * @param includeAuthWrapper - If true, the content will be wrapped in an AuthWrapper component with the heading "You are already signed in".
 * If false, the content will not be wrapped in an AuthWrapper component and only includes the buttons.
 * Default is true.
 */
export function AlreadySignedIn({
  includeAuthWrapper = true,
}: AlreadySignedInProps) {
  const router = useRouter();
  const { signOut } = useClerk();
  const [authLabels] = useLabels("auth");

  const content = (
    <div className="flex flex-col gap-4">
      <Button
        variant="primary"
        onClick={() => router.push(path.HOME)}
        className="w-full"
      >
        Return Home
      </Button>
      <Button
        variant="tertiary"
        onClick={() => signOut({ redirectUrl: path.SIGN_IN })}
        className="w-full"
      >
        Sign Out
      </Button>
    </div>
  );

  return includeAuthWrapper ? (
    <AuthWrapper heading={authLabels.headings["already-signed-in"]}>
      {content}
    </AuthWrapper>
  ) : (
    <>{content}</>
  );
}
